export default "__VITE_ASSET__BQesdGzY__"